import { enUS, ru, kk, de, uk } from 'date-fns/locale';

const localeMap = {
  ru: ru,
  en: enUS,
  kz: kk,
  de: de,
  uk: uk,
};

export const getDateLocale = (locale) => {
  return localeMap[locale];
};
